module.exports = __webpack_public_path__ + "static/img/toady.79e90a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/toady.png
// module id = wI7p
// module chunks = 1